// @flow
import React from "react";
import styled, { css } from "styled-components";
import { connect, type MapStateToProps } from "react-redux";
import Gettext, { inferMomentLocale } from "../common/Gettext";

import type { State as ReduxState } from "../../redux/reducer/index";
import { fontSize } from "../common/styled-mixins";

const Container = styled.div`
  /* position: absolute;
  bottom: 85px;
  left: 50%;
  transform: translate(-50%, 0); */
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 62px;
  padding: 0 20px;
  white-space: pre-wrap;
  font-size: ${fontSize(16)};
  color: #717171;
  background-color: #f6f6f6;
  line-height: 1.2;

  @media (max-width: 959px) {
    bottom: 15px;
    height: 54px;
    font-size: ${fontSize(14)};
  }

  @media (max-width: 479px) {
    font-size: ${fontSize(12)};
  }

  ${props =>
    props.error &&
    css`
      color: ${props => props.theme.lower};
    `};
`;

type Props = {
  loading: boolean,
  locale: string,
  error: string | null,
  startDate: null | moment$Moment,
  endDate: null | moment$Moment
};

function NoData({ loading, locale, error, startDate, endDate }: Props) {
  if (loading === true) {
    return <Container />;
  }

  if (error) {
    return <Container error>{error}</Container>;
  }

  if (startDate !== null && endDate !== null) {
    const start = startDate.locale(locale).format("DD.MM.YYYY");
    const end = endDate.locale(locale).format("DD.MM.YYYY");

    return (
      <Container>
        <Gettext>No operations found for the period</Gettext>: {start} - {end}
      </Container>
    );
  }

  return null;
}

const mapStateToProps = (state: ReduxState) => ({
  locale: inferMomentLocale(state)
});

export default connect((mapStateToProps: MapStateToProps<*, *, *>))(NoData);



// WEBPACK FOOTER //
// ./src/components/HistoryPages/NoData.js